export const DAYS_OF_WEEK = {
  SUNDAY: {api_name: 'Sunday', display: 'Sunday', value: 'Sunday', showOrder: 0, def: false},
  MONDAY: {api_name: 'Monday', display: 'Monday', value: 'Monday', showOrder: 1, def: false},
  TUESDAY: {api_name: 'Tuesday', display: 'Tuesday', value: 'Tuesday', showOrder: 2, def: false},
  WEDNESDAY: {api_name: 'Wednesday', display: 'Wednesday', value: 'Wednesday', showOrder: 3, def: false},
  THURSDAY: {api_name: 'Thursday', display: 'Thursday', value: 'Thursday', showOrder: 4, def: false},
  FRIDAY: {api_name: 'Friday', display: 'Friday', value: 'Friday', showOrder: 5, def: false},
  SATURDAY: {api_name: 'Saturday', display: 'Saturday', value: 'Saturday', showOrder: 6, def: false},
}